import { view } from '@risingstack/react-easy-state';

export default view;
